/**
 * Llamadas a la API de configuración global del tablero.
 */
import {
  configuracionSchema,
  etiquetasPrioridadSchema,
  type EtiquetasPrioridad,
} from '@cdtec-backlog/contrato';
import { solicitar } from '../../lib/api';

export const obtenerConfiguracion = () =>
  solicitar('/configuracion', { esquema: configuracionSchema });

/** Solo ADMIN (la API lo exige). Devuelve los nombres ya normalizados. */
export const guardarPrioridades = (etiquetas: EtiquetasPrioridad) =>
  solicitar('/configuracion/prioridades', {
    metodo: 'PUT',
    cuerpo: etiquetas,
    esquema: etiquetasPrioridadSchema,
  });
